module.exports = __webpack_public_path__ + "img/eu.74de81f9.svg";